function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 2.002,
  y: 202.933,
  fill: "#512B65",
  width: 72.029,
  height: 19.3
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 82.425,
  y: 115.618,
  transform: "matrix(-0.766 -0.6428 0.6428 -0.766 83.6054 283.6639)",
  fill: "#75E2EE",
  width: 22.001,
  height: 21.999
}));

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M148.705,60.739c-4.652-3.905-11.592-3.297-15.496,1.355L92.068,111.12l16.854,14.142l41.141-49.026 C153.967,71.583,153.359,64.644,148.705,60.739z"
});

var _ref5 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#00ADC0",
  d: "M81.176,120.572l-34.531-9.253c-10.361-2.776-20.998,3.368-23.773,13.729L2.002,202.933l72.029,19.3 L94.9,144.35C97.676,133.988,91.537,123.349,81.176,120.572z"
});

var _ref6 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M70.518,55.985c-11.057,0-20.031,8.968-20.031,20.031c0,2.929,0,39.923,0,39.923l26.951,9.286V104.53h8.049 V91.754h5.064c0,0,0-12.809,0-15.737C90.551,64.953,81.578,55.985,70.518,55.985z"
});

var _ref7 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M70.518,55.985c-11.057,0-20.031,8.968-20.031,20.031c0,1.449,0,11.34,0,20.961l11.375-13.432 c-2.613,0-4.723-2.112-4.723-4.716s2.109-4.709,4.723-4.709c2.59,0,4.699,2.105,4.699,4.709c0,0,6.893-1.136,12.615-4.088 c5.703-2.957,9.449-7.236,9.449-7.236C85.436,60.701,78.531,55.985,70.518,55.985z"
}));

var _ref8 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#333333",
  d: "M50.51,125.29c0-15.871,0-41.751,0-41.751h11.352v41.751H50.51z"
});

var _ref9 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#75E2EE",
  d: "M48.283,130.471c-4.977-3.484-11.834-2.275-15.32,2.701l-12.617,18.022l18.021,12.617l12.619-18.021 C54.471,140.814,53.26,133.955,48.283,130.471z"
});

var _ref10 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M23.113,185.6l15.254-21.788l-18.021-12.617L3.486,175.27c-2.806,2.687-4.1,6.779-3.023,10.799l8.281,30.909 c1.572,5.867,7.604,9.351,13.471,7.779c5.869-1.573,9.352-7.604,7.779-13.472L23.113,185.6z"
});

var _ref11 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("rect", {
  x: 243.238,
  y: 202.933,
  fill: "#512B65",
  width: 72.029,
  height: 19.3
});

var _ref12 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 212.845,
  y: 115.617,
  transform: "matrix(0.766 -0.6428 0.6428 0.766 -29.0183 173.5065)",
  fill: "#FFCACC",
  width: 22.001,
  height: 22
}));

var _ref13 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M225.201,111.12l-41.141-49.025c-3.904-4.652-10.842-5.261-15.496-1.355 c-4.654,3.904-5.26,10.844-1.355,15.496l41.139,49.026L225.201,111.12z"
});

var _ref14 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#C15E62",
  d: "M236.094,120.572l34.531-9.253c10.361-2.776,20.998,3.368,23.775,13.729l20.867,77.884l-72.029,19.3 l-20.867-77.883C219.594,133.988,225.732,123.349,236.094,120.572z"
});

var _ref15 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M246.752,55.985c-11.061,0-20.033,8.968-20.033,20.031c0,2.929,0,15.737,0,15.737h5.064v12.776h8.049v20.695 l26.951-9.286c0,0,0-36.994,0-39.923C266.783,64.953,257.809,55.985,246.752,55.985z"
});

var _ref16 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M246.752,55.985c11.057,0,20.031,8.968,20.031,20.031c0,1.449,0,11.34,0,20.961l-11.375-13.432 c2.613,0,4.723-2.112,4.723-4.716s-2.109-4.709-4.723-4.709c-2.59,0-4.699,2.105-4.699,4.709c0,0-6.893-1.136-12.615-4.088 c-5.703-2.957-9.449-7.236-9.449-7.236C231.834,60.701,238.738,55.985,246.752,55.985z"
}));

var _ref17 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#FFCACC",
  d: "M284.307,133.172c-3.484-4.976-10.344-6.186-15.32-2.701s-6.186,10.344-2.701,15.32l12.619,18.021 l18.021-12.617L284.307,133.172z"
});

var _ref18 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  fill: "#EE99CC",
  d: "M315.279,177.406l-18.354-26.212l-18.021,12.617l15.376,21.963l-6.937,25.893 c-1.572,5.868,1.91,11.899,7.779,13.472c5.867,1.572,11.898-1.912,13.471-7.778l8.023-29.941 C317.775,184.176,317.405,180.442,315.279,177.406z"
});

var _ref19 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#242424",
  d: "M161.189,48.528V45.83c11.494-1.271,20.432-11.011,20.434-22.844c0-12.697-10.293-22.987-22.99-22.986 c-12.693,0-22.986,10.29-22.984,22.987c-0.002,11.834,8.938,21.572,20.434,22.843v2.698h-1.279v35.759l7.664-0.001V48.528H161.189z "
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#C8E2E4",
  cx: 158.636,
  cy: 22.988,
  r: 17.88
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92C5C9",
  d: "M171.832,10.943l-30.225,17.451c0.785,2.462,2.092,4.727,3.834,6.637l30.223-17.45 C174.879,15.118,173.572,12.854,171.832,10.943z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#ADD4D7",
  d: "M175.535,17.146l-30.406,17.557c1.824,2.106,4.162,3.797,6.879,4.878l24.314-14.038 C176.742,22.648,176.447,19.779,175.535,17.146z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#77B7BC",
  d: "M175.906,27.615c0.232-0.871,0.375-1.744,0.475-2.615l-24.873,14.361c0.803,0.35,1.629,0.662,2.502,0.896 C163.547,42.813,173.35,37.153,175.906,27.615z"
}));

var SvgQueEsObs00 = function SvgQueEsObs00(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "318px",
    height: "226px",
    viewBox: "0 0 318 226",
    enableBackground: "new 0 0 318 226",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQueEsObs00, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/queEsObs_00.354c44b3.svg";
export { ForwardRef as ReactComponent };